"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CHUIFooter;

var _ChuiContext = require("../Hooks/ChuiContext");

var _material = require("@mui/material");

var _react = _interopRequireWildcard(require("react"));

var _iconsMaterial = require("@mui/icons-material");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CHUIFooter(props) {
  var _useCHUIDarkModeConte = (0, _ChuiContext.useCHUIDarkModeContext)(),
      prefersDarkMode = _useCHUIDarkModeConte.prefersDarkMode;

  var theme = (0, _material.useTheme)();
  var breakPoint = (0, _material.useMediaQuery)(theme.breakpoints.up("md"));

  if (breakPoint) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Paper, {
      square: true,
      elevation: prefersDarkMode ? 6 : 1,
      sx: {
        padding: 2,
        backgroundColor: prefersDarkMode ? null : "primary.main",
        color: prefersDarkMode ? null : "primary.contrastText"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Container, {
      maxWidth: "md"
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      xs: 6,
      sx: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        padding: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_material.List, null, /*#__PURE__*/_react.default.createElement(_material.ListItem, null, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://www.connecthealth.co.uk/app/themes/connecthealth/img/connect-footer-logo.png",
      alt: "Connect Health"
    })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      xs: 6,
      sx: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        padding: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "h6",
      sx: {
        textAlign: "center",
        p: 1
      }
    }, "Social Media"), /*#__PURE__*/_react.default.createElement(_material.Stack, {
      divider: /*#__PURE__*/_react.default.createElement(_material.Divider, {
        orientation: "vertical",
        flexItem: true,
        sx: {
          borderColor: prefersDarkMode ? null : "primary.light"
        }
      }),
      justifyContent: "center",
      alignItems: "center",
      direction: {
        xs: "column",
        sm: "column",
        md: "row"
      },
      spacing: {
        xs: 1,
        sm: 2,
        md: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://twitter.com/Connect_Health_"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Twitter, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://www.facebook.com/ConnectPhysiotherapy"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Facebook, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://www.linkedin.com/company/connect-physical-health"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.LinkedIn, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://www.youtube.com/channel/UCJxTRmBrEksa2G7E1jwJ9FA"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.YouTube, null)))))))), /*#__PURE__*/_react.default.createElement(_material.Paper, {
      square: true,
      elevation: prefersDarkMode ? 4 : 1,
      sx: {
        padding: 3,
        textAlign: "center",
        backgroundColor: prefersDarkMode ? null : "primary.light",
        color: prefersDarkMode ? null : "primary.contrastText"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "CONNECT HEALTH \xAE")));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Paper, {
      square: true,
      elevation: prefersDarkMode ? 6 : 1,
      sx: {
        padding: 2,
        backgroundColor: prefersDarkMode ? null : "primary.main",
        color: prefersDarkMode ? null : "primary.contrastText"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Container, {
      sx: {
        p: 3
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      style: {
        display: "block",
        margin: "0 auto"
      },
      src: "https://www.connecthealth.co.uk/app/themes/connecthealth/img/connect-footer-logo.png",
      alt: "Connect Health"
    })), /*#__PURE__*/_react.default.createElement(_material.Stack, {
      divider: /*#__PURE__*/_react.default.createElement(_material.Divider, {
        orientation: "vertical",
        flexItem: true,
        sx: {
          borderColor: prefersDarkMode ? null : "primary.light",
          mt: 4
        }
      }),
      justifyContent: "center",
      alignItems: "center",
      direction: {
        xs: "column",
        sm: "column",
        md: "row"
      },
      spacing: {
        xs: 1,
        sm: 2,
        md: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://twitter.com/Connect_Health_"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Twitter, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://www.facebook.com/ConnectPhysiotherapy"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Facebook, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://www.linkedin.com/company/connect-physical-health"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.LinkedIn, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
      color: "inherit",
      href: "https://www.youtube.com/channel/UCJxTRmBrEksa2G7E1jwJ9FA"
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.YouTube, null))))), /*#__PURE__*/_react.default.createElement(_material.Paper, {
      square: true,
      elevation: prefersDarkMode ? 4 : 1,
      sx: {
        padding: 3,
        textAlign: "center",
        backgroundColor: prefersDarkMode ? null : "primary.light",
        color: prefersDarkMode ? null : "primary.contrastText"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "CONNECT HEALTH \xAE")));
  }
}